"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionEquipmentEventTransport = exports.SubscriptionEquipmentUpdate = exports.SubscriptionEquipmentCreate = exports.SubscriptionEquipmentQuery = exports.SubscriptionEquipmentTransport = exports.SubscriptionEquipment = exports.SubscriptionEquipmentType = exports.SubscriptionEquipmentTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const enums_1 = require("../enums");
const CommercialLineItem_1 = require("./CommercialLineItem");
// 'CONTAINER' is for any service where the vendor provides the container. 'LOOSE' is for bulk pickup where there is no container.
// There is currently no provision for a customer-provided container, but there's no reason we can't add that when and if needed.
exports.SubscriptionEquipmentTypes = ['CONTAINER', 'PORTABLE_TOILET', 'LOOSE'];
exports.SubscriptionEquipmentType = typebox_1.Type.Union(exports.SubscriptionEquipmentTypes.map((type) => typebox_1.Type.Literal(type)));
exports.SubscriptionEquipment = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    routePlanTemplateStopIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }), {
        description: 'Active planned stops assigned to this container. Inactive stops are not included.',
    }),
    subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    lineItem: typebox_1.Type.Optional(CommercialLineItem_1.CommercialLineItemTransport),
    type: exports.SubscriptionEquipmentType,
    pickupCycleUnit: enums_1.PickupCycleUnit, // The unit of time for the pickup cycle. Usually 'WEEK'.
    pickupCycleLength: typebox_1.Type.Integer({ minimum: 1 }), // The number of units that make up the pickup cycle. For example, 1 week, 2 weeks, 1 month, etc.
    pickupsPerCycle: typebox_1.Type.Integer({ minimum: 1 }), // The number of pickups in a cycle. For example, 1 pickup per week, 2 pickups per month, etc.
    requestedCount: typebox_1.Type.Integer({
        minimum: 0,
        description: 'Quantity customer has *requested* to be present on site',
    }),
    expectedCount: typebox_1.Type.Integer({
        minimum: 0,
        description: 'Actual number of containers *expected* to be found on site today',
    }),
    containerTypeID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    material: common_1.Material,
    equipmentAssignmentIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))),
    status: enums_1.SubscriptionEquipmentStatus,
    metadata: common_1.MetaData,
});
exports.SubscriptionEquipmentTransport = exports.SubscriptionEquipment;
exports.SubscriptionEquipmentQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        haulerID: typebox_1.Type.String({ format: 'uuid' }),
        subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.SubscriptionEquipmentCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.SubscriptionEquipment, [
        'id',
        'haulerID',
        'routePlanTemplateStopIDs',
        'equipmentAssignmentIDs',
        'status',
        'subscriptionID',
        'lineItem',
        'metadata',
    ]),
    typebox_1.Type.Object({
        lineItem: typebox_1.Type.Optional(CommercialLineItem_1.CommercialLineItemNestedCreate),
        status: typebox_1.Type.Optional(enums_1.SubscriptionEquipmentStatus),
    }),
]);
// This is a little experiment I'm trying for a standard format we can use for
// these optional one-to-one relations in update payloads. If it works well, it
// can be used everywhere we have the same pattern.
const SubscriptionEquipmentUpdateLineItem = typebox_1.Type.Object({
    action: typebox_1.Type.Union([typebox_1.Type.Literal('REPLACE'), typebox_1.Type.Literal('REMOVE'), typebox_1.Type.Literal('UPDATE')]),
    payload: typebox_1.Type.Optional(typebox_1.Type.Union([CommercialLineItem_1.CommercialLineItemNestedCreate, CommercialLineItem_1.CommercialLineItemUpdate])),
});
exports.SubscriptionEquipmentUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.SubscriptionEquipment, [
        'id',
        'haulerID',
        'lineItem',
        'containerTypeID',
        'metadata',
        'equipmentAssignmentIDs',
    ]),
    typebox_1.Type.Object({
        lineItem: SubscriptionEquipmentUpdateLineItem,
        containerTypeID: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'uuid' })),
    }),
]));
exports.SubscriptionEquipmentEventTransport = typebox_1.Type.Object({});
//# sourceMappingURL=SubscriptionEquipment.js.map